import React from "react"

import rayIcon from "../../../assets/images/order/rays.png"

interface SectionTitleProps {
  title: React.ReactNode
  withRays?: boolean
}

export function FeatureSectionTitle({
  title,
  withRays = false,
}: SectionTitleProps) {
  return (
    <div className="tw-text-center tw-mb-10 tw-relative tw-pt-10">
      <div className="tw-relative tw-inline-block">
        {withRays && (
          <img
            className="blue-rays tw-relative tw-left-1/2 tw-transform tw--translate-x-1/2 tw-w-24 tw-h-[40px]"
            src={rayIcon}
            alt="Decorative rays"
          />
        )}
        <h2 className="tw-text-3xl tw-font-extrabold tw-text-gray-800 tw-my-0 tw-py-2.5">
          {title}
        </h2>
      </div>
    </div>
  )
}
